import React, { Component } from "react";
import PropTypes from "prop-types";

import * as productRepo from "../../shared/repos/graphql/product";
import Loader from "../Loader/Loader";

export default class ProductRedirect extends Component {
  componentDidMount = async () => {
    const { match, history, location } = this.props;
    const { params } = match;
    const { id } = params;
    const search = location?.search || '';
    const { data } = await productRepo.getProduct(id);

    const product = data?.product;

    if(product) {
        history.push(`/products/${product.productSlug}${search}`);
    } else {
        history.push(`/menu`);
    }
  };

  render() {
    return <div className="flex items-center justify-center h-full w-full"><Loader /></div>;
  }
}

ProductRedirect.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string
  })
};

ProductRedirect.defaultProps = {
  location: { search: '' }
};
